import { ValidTelemetryEvent, Telemetry } from '../../../../commonInfra/services/Telemetry';

// List of events. The event name will be what appears in the database.
export enum CreateContentTelemetryEvents {
  openMenu = 'CreateContentMenu_OpenMenu',
  selectItem = 'CreateContentMenu_selectItem'
}

export interface CreateContentOpenMenuEvent extends ValidTelemetryEvent<CreateContentOpenMenuEvent> {
  type: CreateContentTelemetryEvents.openMenu;
  location: string;
}

export interface CreateContentSelectItemEvent extends ValidTelemetryEvent<CreateContentSelectItemEvent> {
  type: CreateContentTelemetryEvents.selectItem;
  location: string;
  actionName: string;
}

export function sendCreateContentOpenMenuTelemetry(location: string) {
  Telemetry.sendEvent<CreateContentOpenMenuEvent>({
    type: CreateContentTelemetryEvents.openMenu,
    location
  });
}

export function sendCreateContentSelectItemTelemetry(location: string, actionName: string) {
  Telemetry.sendEvent<CreateContentSelectItemEvent>({
    type: CreateContentTelemetryEvents.selectItem,
    location,
    actionName
  });
}
